module.exports = __webpack_public_path__ + "media/images/icons/file-medical-3589a841f458348d653a3273127b900b.png";